import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { CURRENT_CLIENT_TEMPLATE_VAR } from '@core';
import type { DeviceAttribute, DeviceAttributeType, MeasurementUnitEntity } from '@devices';
import { map, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DeviceAttributeService {
  private http = inject(HttpClient);

  getAttributes() {
    return this.http
      .get<{ data: DeviceAttribute[]; }>(`devices/v1/clients/${CURRENT_CLIENT_TEMPLATE_VAR}/device-attributes`)
      .pipe(map(response => response.data));
  }

  deleteAttribute(attributeId: string) {
    return this.http.delete(`devices/v1/clients/${CURRENT_CLIENT_TEMPLATE_VAR}/device-attributes/${attributeId}`);
  }

  getDataPointsMeasurementUnits() {
    return this.http
      .get<{ data: MeasurementUnitEntity[]; }>(`devices/v1/clients/${CURRENT_CLIENT_TEMPLATE_VAR}/measurement-units`)
      .pipe(map(response => response.data));
  }

  updateDataPoint(attributeId: string, data: { measurementUnitId: string; name: string; }) {
    return this.http
      .patch<{ data: DeviceAttribute; }>(
        `devices/v1/clients/${CURRENT_CLIENT_TEMPLATE_VAR}/device-attributes/${attributeId}`,
        data,
      )
      .pipe(map(response => response.data));
  }

  addNewAttribute(data: { measurementUnitId?: string; name: string; type: DeviceAttributeType; }): Observable<DeviceAttribute> {
    return this.http
      .post<{ data: DeviceAttribute; }>(`devices/v1/clients/${CURRENT_CLIENT_TEMPLATE_VAR}/device-attributes`, data)
      .pipe(map(response => response.data));
  }
}
